export const twoFactorErrorMessage = (error: IErrorResponse) =>
  error.errors?.code?.[0] ?? error.errors?.email?.[0] ??
  error.errors?.session_reference?.[0] ?? error.message;

export const isAccountLockout = (error: IErrorResponse) =>
  error.httpStatus === 429 && error.status === false && Number(error.code) === 429;

export const formatTwoFactorDeadline = (deadline: string) => {
  const date = new Date(deadline);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat(undefined, {
    weekday: "short", day: "numeric", month: "short", year: "numeric",
    hour: "numeric", minute: "2-digit", timeZoneName: "short",
  }).format(date);
};

export const adminDisabledReason = (reason?: string | null) => {
  if (reason === "2fa_not_setup") return "2FA not set up in time";
  if (reason === "manual") return "Disabled by an admin";
  return "Reason unavailable";
};
